import { z } from 'zod';

export const schema = z.object({
  email: z.string().email().min(1),
  password: z
    .string()
    .refine(
      value =>
        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,}$/.test(value),
      'Minimum eight characters, at least one number and one special character'
    ),
});
